/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre",
    h3: "h3",
    ul: "ul",
    li: "li",
    a: "a",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Why am I getting a warning about several instances of module on the page?"
    }), "\n", _jsxs(_components.p, {
      children: ["If you are seeing a warning message in the console like the one below, you probably\nhave several instances of ", _jsx(_components.code, {
        children: "styled-components"
      }), " initialized on the page."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-sh",
        children: "It looks like there are several instances of \"styled-components\" initialized in this application. This may cause dynamic styles not rendering properly, errors happening during rehydration process and makes you application bigger without a good reason.\n\nIf you are using a building tool like webpack, consider checking your bundle for duplication of the \"styled-components\" module.\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "This may cause dynamic styles not working properly or even errors during rehydration if\nyou are using server-side rendering."
    }), "\n", _jsx(_components.h3, {
      children: "Possible reasons"
    }), "\n", _jsx(_components.p, {
      children: "There are several common reasons for this to happen:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["You have several applications that are using ", _jsx(_components.code, {
          children: "styled-components"
        }), " running on the same page\n(e.g., several entry points in webpack are loaded on the same page)"]
      }), "\n", _jsxs(_components.li, {
        children: ["You have another ", _jsx(_components.code, {
          children: "styled-components"
        }), " library somewhere in your dependencies"]
      }), "\n", _jsxs(_components.li, {
        children: ["You have a monorepo structure for your project (e.g, lerna, yarn workspaces) and ", _jsx(_components.code, {
          children: "styled-components"
        }), "\nmodule is a dependency in more than one package (this one is more or less the same as the previous one)"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Running multiple applications on one page"
    }), "\n", _jsxs(_components.p, {
      children: ["If you have several applications running on one page, consider using one ", _jsx(_components.code, {
        children: "styled-components"
      }), " module for all of them. If you are using webpack, you can use ", _jsx(_components.a, {
        href: "https://webpack.js.org/plugins/commons-chunk-plugin/",
        children: "CommonsChunkPlugin"
      }), "\nto create an ", _jsx(_components.a, {
        href: "https://webpack.js.org/plugins/commons-chunk-plugin/#explicit-vendor-chunk",
        children: "explicit vendor chunk"
      }), ",\nthat will contain the ", _jsx(_components.code, {
        children: "styled-components"
      }), " module:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "  module.exports = {\n    entry: {\n+     vendor: [\"styled-components\"],\n      app1: \"./src/app.1.js\",\n      app2: \"./src/app.2.js\",\n    },\n    plugins: [\n+     new webpack.optimize.CommonsChunkPlugin({\n+       name: \"vendor\",\n+       minChunks: Infinity,\n+     }),\n    ]\n  }\n"
      })
    }), "\n", _jsxs(_components.h3, {
      children: ["Duplicated module in ", _jsx(_components.code, {
        children: "node_modules"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["If you think that the issue is in duplicated ", _jsx(_components.code, {
        children: "styled-components"
      }), " module somewhere in your dependencies, there are several ways to check this. You can use ", _jsx(_components.code, {
        children: "npm ls styled-components"
      }), ", ", _jsx(_components.code, {
        children: "yarn list --pattern styled-components"
      }), " or ", _jsx(_components.code, {
        children: "find -L ./node_modules | grep /styled-components/package.json"
      }), " commands in your application folder."]
    }), "\n", _jsxs(_components.p, {
      children: ["If none of these commands identified the duplication, try analyzing your bundle for multiple instances of ", _jsx(_components.code, {
        children: "styled-components"
      }), ". You can just check your bundle source, or use a tool like ", _jsx(_components.a, {
        href: "https://github.com/danvk/source-map-explorer",
        children: "source-map-explorer"
      }), "\nor ", _jsx(_components.a, {
        href: "https://github.com/webpack-contrib/webpack-bundle-analyzer",
        children: "webpack-bundle-analyzer"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "If you identified that duplication is the issue that you are encountering there are several things you can try to solve it:"
    }), "\n", _jsxs(_components.p, {
      children: ["If you are using ", _jsx(_components.code, {
        children: "npm"
      }), " you can try running ", _jsx(_components.code, {
        children: "npm dedupe"
      }), ". This command searches the local dependencies and tries to simplify the structure by moving common dependencies further up the tree."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Be aware that ", _jsx(_components.code, {
          children: "npm dedupe"
        }), " doesn't work well with symlinked folders (i.e., when you use ", _jsx(_components.code, {
          children: "npm link"
        }), ")"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["If you are using webpack, you can change the way it will ", _jsx(_components.a, {
        href: "https://webpack.js.org/configuration/resolve/#resolve-modules",
        children: "resolve"
      }), "\nthe ", _jsx(_components.code, {
        children: "styled-components"
      }), " module. You can overwrite the default order in which webpack will look for your dependencies and make your application ", _jsx(_components.code, {
        children: "node_modules"
      }), " more prioritized than default node module resolution order:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "  resolve: {\n+   alias: {\n+     \"styled-components\": path.resolve(appFolder, \"node_modules\", \"styled-components\"),\n+   }\n  }\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Usage with Lerna"
    }), "\n", _jsxs(_components.p, {
      children: ["One possible fix to get styled-components to run in a Lerna monorepo across packages, is to ", _jsx(_components.a, {
        href: "https://github.com/lerna/lerna/blob/master/doc/hoist.md#disadvantages-with-hoisting",
        children: "hoist"
      }), " shared dependencies to the root of your monorepo file. Try running the bootstrap option with the --hoist flag."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-sh",
        children: "lerna bootstrap --hoist\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Alternatively, you can remove ", _jsx(_components.code, {
        children: "styled-components"
      }), " from your ", _jsx(_components.code, {
        children: "package.json"
      }), " file and hoist it manually to your top-level package.json file."]
    }), "\n", _jsx(_components.p, {
      children: "Example of a package.json file in a Lerna root folder"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        children: "{\n  \"name\": \"my-styled-monorepo\",\n  \"devDependencies\": {\n    \"lerna\": \"3.6.0\"\n  },\n  \"dependencies\": {\n    \"styled-components\": \"3.4.5\"\n  },\n  \"scripts\": {\n    \"bootstrap\": \"lerna bootstrap\",\n    \"clean\": \"lerna clean\",\n    \"start\": \"lerna run start\",\n    \"build\": \"lerna run build\"\n  }\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
